<template>
  <div @click="tableSwap" v-if="!table" class="shadow-sharp fixed right-3 bottom-3 flex justify-center items-center w-16 h-8 bg-default rounded-full shadow hover:shadow-lg cursor-pointer">
    <Icon class="z-20 text-lg text-white select-none" :icon="['fas', 'arrow-up']"/>&nbsp;<Icon class="z-20 text-lg text-white select-none" :icon="['fas', 'table']"/>
  </div>
  <div v-if="table">
    <div @click="tableSwap" class="z-30 shadow-sharp fixed right-3 bottom-3 flex justify-center items-center w-16 h-8 bg-white rounded-full shadow hover:shadow-lg cursor-pointer">
      <Icon class="text-lg text-default select-none" :icon="['fas', 'arrow-down']"/>&nbsp;<Icon class="text-lg text-default select-none" :icon="['fas', 'table']"/>
    </div>
    <div class="shadow-sharp fixed right-0 -bottom-3 flex flex-col items-center w-64 h-96 bg-default rounded-lg shadow hover:shadow-lg">
      <p class="text-white text-xl m-3 cursor-default">Datasets</p>
      <DatasetHolder />
    </div>
  </div>
</template>

<script>
import DatasetHolder from '@/components/DatasetHolder'

export default {
  name: 'DataTable',
  components: {
    DatasetHolder
  },
  data: function () {
    return {
      table: false
    }
  },
  methods: {
    tableSwap: function () {
      this.table = !this.table
    }
  }
}
</script>

<style scoped>

</style>
